import { Flex } from 'antd';
import { useState } from 'react';

import ClientProfileSelector from '@/components/auth/ClientProfileSelector';
import Loader from '@/UI/Loader';

import { useMagicLink } from './hooks';

import type { AvailableClientProfile } from '@/types/user';

const MagicLink = () => {
  const [showProfileSelector, setShowProfileSelector] = useState(false);
  const [availableProfiles, setAvailableProfiles] = useState<
    AvailableClientProfile[]
  >([]);

  const { handleProfileSelect, handleCancel, loading } = useMagicLink({
    setShowProfileSelector,
    setAvailableProfiles,
  });

  return (
    <Flex align="center" justify="center">
      <Loader spinning={!showProfileSelector && loading}></Loader>
      <ClientProfileSelector
        open={showProfileSelector}
        profiles={availableProfiles}
        onSelect={handleProfileSelect}
        onCancel={handleCancel}
        loading={loading}
      />
    </Flex>
  );
};

export default MagicLink;
